import { SEO, RockHallTv, SoundPopup, ClientPortal } from "@components";
import { usePageHighlight } from "@/providers/PageHighlightContext";
import { HIGHLIGHT_COLORS } from "@/core/constants";
import { useEffect } from "react";
import { RhtvPageFieldsFragment } from "@/__generated__/graphql";
import { RockHallTVProvider } from "@/providers/RockHallTVContext";
import { useViewSize } from "@/providers/ViewSizeContext";
import { usePageLoading } from "@/providers/LoadingContext";
import { useTrackRouteChange } from "@/providers/TrackingContext";

type RockHallTVViewProps = {
  page?: RhtvPageFieldsFragment | null;
  channels: RockHallTvChannel[];
  defaultChannel: RockHallTvChannel | null;
  defaultVideo: RockHallTvVideo | null;
  isPreview?: boolean;
};

const RockHallTVView = ({ page, channels, defaultChannel, defaultVideo, isPreview = false }: RockHallTVViewProps) => {
  const { setHighlightColor } = usePageHighlight();
  const { isDesktop } = useViewSize();
  const { previewLoading, setPreviewLoading } = usePageLoading();
  const { rhtvPageContent, pageData } = page || {};
  const { pageCategory, ogDescription, ogTitle, featuredImage } = pageData || {};
  const [category] = pageCategory || [];

  useEffect(() => {
    setHighlightColor(HIGHLIGHT_COLORS.PINK);
  }, []);
  useTrackRouteChange(category?.slug);

  useEffect(() => {
    if (previewLoading) setPreviewLoading(false);
  }, [previewLoading]);

  return (
    <>
      <SEO title={ogTitle} description={ogDescription} image={featuredImage} />
      <RockHallTVProvider
        channels={channels}
        defaultChannel={defaultChannel}
        defaultVideo={defaultVideo}
        isPreview={isPreview}
      >
        <RockHallTv channels={channels} content={rhtvPageContent} />
        <ClientPortal selector="portal" show={isDesktop}>
          <SoundPopup headlineOverride={rhtvPageContent?.soundPopupHeadlineOverride} />
        </ClientPortal>
      </RockHallTVProvider>
    </>
  );
};

export default RockHallTVView;
